var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25321 6.21886C7.0755 6.43207 6.98564 6.70493 7.00187 6.98201V19.0188C6.98656 19.2957 7.07631 19.5682 7.25321 19.7819L7.29434 19.823L14.0347 13.0781V12.9181L7.29434 6.17773L7.25321 6.21886Z",
    fill: "url(#paint0_linear_3643:9683)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.283 15.3278L14.0347 13.0795V12.9195L16.283 10.6758L16.3333 10.7032L18.9974 12.2158C19.7606 12.6453 19.7606 13.3537 18.9974 13.7878L16.3333 15.3004L16.283 15.3278Z",
    fill: "url(#paint1_linear_3643:9683)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 15.3005L14.0484 13.0156L7.25317 19.7834C7.4098 19.9122 7.60481 19.9852 7.80749 19.991C8.01018 19.9968 8.20904 19.935 8.37276 19.8154L16.3196 15.3005",
    fill: "url(#paint2_linear_3643:9683)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 10.7023L8.37276 6.18276C8.21079 6.05823 8.01062 5.9938 7.80642 6.00047C7.60222 6.00714 7.40667 6.08449 7.25317 6.21932L14.0347 13.0008L16.3333 10.7023Z",
    fill: "url(#paint3_linear_3643:9683)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.2831 15.25L8.3728 19.7375C8.21501 19.8551 8.02349 19.9186 7.82672 19.9186C7.62994 19.9186 7.43842 19.8551 7.28063 19.7375L7.2395 19.7786L7.28063 19.8198C7.43842 19.9373 7.62994 20.0008 7.82672 20.0008C8.02349 20.0008 8.21501 19.9373 8.3728 19.8198L16.3196 15.3048L16.2831 15.25Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M7.25307 19.7091C7.07588 19.4939 6.98616 19.2198 7.00174 18.9414V19.0191C6.98642 19.2961 7.07618 19.5686 7.25307 19.7822L7.2942 19.7411L7.25307 19.7091Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M18.9976 13.7044L16.2832 15.249L16.3335 15.2993L18.9976 13.7684C19.1539 13.6997 19.2891 13.5907 19.3895 13.4526C19.4898 13.3145 19.5517 13.1523 19.5689 12.9824C19.5377 13.1394 19.4696 13.2868 19.3703 13.4123C19.271 13.5378 19.1433 13.638 18.9976 13.7044Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M8.37361 6.26425L18.9983 12.2918C19.1425 12.3566 19.2694 12.4545 19.3686 12.5776C19.4679 12.7007 19.5367 12.8454 19.5695 13.0001C19.5533 12.8299 19.4918 12.6673 19.3913 12.529C19.2909 12.3908 19.1551 12.282 18.9983 12.2141L8.37361 6.182C7.62417 5.75244 7.00269 6.10888 7.00269 6.9817V7.05939C7.00269 6.19114 7.62417 5.83013 8.37361 6.26425Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3643:9683",
    x1: 13.4407,
    y1: 6.85406,
    x2: 4.30572,
    y2: 15.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#008FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3643:9683",
    x1: 19.0888,
    y1: 13.0018,
    x2: 5.91878,
    y2: 13.0018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3643:9683",
    x1: 15.0857,
    y1: 14.2495,
    x2: 2.7017,
    y2: 26.6335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B11162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3643:9683",
    x1: 5.54408,
    y1: 2.21164,
    x2: 11.0781,
    y2: 7.74104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#328E71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2D9571"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15BD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06D575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DE76"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/GooglePlay.2592e1b671ff4abaa47fcb9dc88089e3.svg";
export { ForwardRef as ReactComponent };